
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import Multiselect from '@vueform/multiselect';

  export default defineComponent({
    name: 'ire-investment-filter',
    emit: ['ire-investment-type-selected', 'reset'],
    components: { Multiselect },
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<{ areaId: string | number | '' }>({
        areaId: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        emit('ire-investment-type-selected', { ...selectedItems.value });
      };

      const onReset = () => {
        selectedItems.value = { areaId: '' };
        emit('reset', { ...selectedItems.value });
      };

      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_IRE_INVESTMENT_AREAS);
      });

      return {
        areas: computed(() => store.getters.ireInvestmentAreasAllList || []),
        selectedItems,
        translate,
        onSubmit,
        onReset,
      };
    },
  });
